var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReverseLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 40C3.58172 40 -1.56562e-07 36.4183 -3.49691e-07 32L-1.39876e-06 8C-1.59189e-06 3.58172 3.58172 -1.56562e-07 8 -3.49691e-07L32 -1.39876e-06C36.4183 -1.59189e-06 40 3.58172 40 8L40 32C40 36.4183 36.4183 40 32 40L8 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 32C9.79086 32 8 30.2091 8 28L8 12C8 9.79086 9.79086 8 12 8L28 8C30.2091 8 32 9.79086 32 12L32 28C32 30.2091 30.2091 32 28 32L12 32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 17.01L21 17.01L17 21L13 17.01L16 17.01L16 10L18 10L18 17.01ZM22 30L22 22.99L19 22.99L23 19L27 22.99L24 22.99L24 30L22 30Z",
    fill: "#81909E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32L0.999999 8L-1 8L-1 32L1 32ZM8 1L32 0.999999L32 -1L8 -1L8 1ZM39 8L39 32L41 32L41 8L39 8ZM32 39L8 39L8 41L32 41L32 39ZM39 32C39 35.866 35.866 39 32 39L32 41C36.9706 41 41 36.9706 41 32L39 32ZM32 0.999999C35.866 0.999998 39 4.134 39 8L41 8C41 3.02944 36.9706 -1 32 -1L32 0.999999ZM0.999999 8C0.999998 4.13401 4.13401 1 8 1L8 -1C3.02944 -1 -1 3.02944 -1 8L0.999999 8ZM-1 32C-1 36.9706 3.02944 41 8 41L8 39C4.13401 39 1 35.866 1 32L-1 32Z",
    fill: "#E5E8EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReverseLight);
export default __webpack_public_path__ + "static/media/reverse-light.0e6b4b98de538bcfce5436ce0073087a.svg";
export { ForwardRef as ReactComponent };